import { pushDataLayer } from '@scripts/utils';
import Alpine from 'alpinejs';

Alpine.data('bundleUpsell', (variantIds) => ({
  loading: false,

  async addToCart() {
    if (this.loading) return;
    this.loading = true;

    const items = (variantIds as string)
      .split(',')
      .map((id) => ({
        id,
        quantity: 1,
      }))
      .filter((item) => item.id !== '');

    try {
      await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      // cross-sell banner Add to Cart analytics
      pushDataLayer({
        event: 'crosssell_add_to_cart',
        journey: this.$root?.dataset?.journey,
      });

      // Adding the paired past paper flips the whole cart state (cross-sell banner
      // hides, upsell banner + recommendations appear), so reload to re-evaluate it
      // all. A partial swap can't remove the now-gone banner, leaving it re-clickable.
      window.location.reload();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error({ error });
      this.loading = false;
    }
  },
}));
